export default __webpack_public_path__ + "locales/ko-KR/ConnectDialog.json?hash=8396a09225aaee8b3ecf3decb7361634";